import Cookie from 'js-cookie';

export default class CookieNotice {

  constructor() {
    this.cookieId = 'cookie-notice-accepted';
    this.$element = $('#cookie-notice');
    this.initialized = false;

    // Specify method that popup management should call
    this.popupManagementCall = this.display;
  }

  display() {
    // If initialization has already happened, just return a boolean to indicate
    // state.
    if (Cookie.get(this.cookieId)) {
      return false;
    }

    if (this.initialized) {
      return true;
    }

    if (!this.$element.length) {
      return false;
    }

    // Set cookie and dismiss popup on accept
    this.$element.find('#cookie-notice-accept').on('click', () => {
      Cookie.set(this.cookieId, 'true', { expires: 365 });
      this.$element.parent().addClass('-accepted');
    });

    // Initalize
    this.initialized = true;
    this.$element.addClass('-init');
    // Force browser to run layout...
    this.$element.height();
    // ...then animate in
    this.$element.addClass('-displayed');

    // Focus on dialog control on display
    this.$element.find('#cookie-notice-accept').focus();

    // Periodically check if the cookie may have been set in another tab/window
    setTimeout(() => {
      this.checkForCookie();
    }, 5000);

    return true;
  }

  checkForCookie() {
    if (Cookie.get(this.cookieId)) {
      this.$element.parent().addClass('-accepted');
    } else {
      setTimeout(() => {
        this.checkForCookie();
      }, 5000);
    }
  }

}
